import { ParsedGradient } from '../../types';

import hexToSwiftColorLiteral from './hexToSwiftColorLiteral';

const parseGradientString = (gradient: string): ParsedGradient => {
  const values = /\(([^)]+)\)/.exec(gradient);
  if (values && values[1]) {
    const [angle, ...stops] = values[1].split(', ');

    return {
      angle: {
        deg: angle,
        integer: parseInt(angle, 10),
      },
      stops: stops.map((stop) => {
        const [hex, percent] = stop.split(' ');
        return {
          color: {
            hex,
            swift: hexToSwiftColorLiteral(hex),
          },
          position: {
            percent,
            float: parseFloat(percent) / 100,
          },
        };
      }),
    };
  }
  throw new Error('failed to parse linear-gradient value.');
};

export default parseGradientString;



// WEBPACK FOOTER //
// ../kibble/tokens/formats/utils/parseGradientString.ts